import { UnitType } from '@exodus/currency'

const name = 'hedera'
const displayName = 'Hedera'
const ticker = 'HBAR'
const displayTicker = 'HBAR'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#D6D6D6'
const gradientColors = ['#D6D6D6', '#777777']
const gradientCoords = { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  tinybar: 0,
  HBAR: 8,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (accountId) =>
    `https://app.dragonglass.me/hedera/accounts/${encodeURIComponent(accountId)}`,
  txUrl: (txId) => `https://ledger.hashlog.io/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'HBAR is the cryptocurrency that powers the Hedera network. Hbars are network fuel for applications built on Hedera, can be used for peer-to-peer payments, and help secure the network through a system of weighted voting power.',
  reddit: 'https://www.reddit.com/r/hashgraph',
  twitter: 'https://twitter.com/hashgraph',
  website: 'https://www.hedera.com/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
